export const settings = {
  setShareTitle: 'Condividi App',
  setNotifiationsTitle: 'Notifiche',
  setContactAppOwnerTitle: "Contatta il proprietario dell'app",
  setContactDevelopersTitle: 'Contatta gli sviluppatori',
  setReportAppTitle: 'Segnala App',
  setDeleteAccountTitle: 'Elimina Account',
  setLogOutTitle: 'Disconnetti',
  setShareAppCurtainTitle: 'Condividi App',
  setShareAppCurtainButtonTitle: 'Copia link',
  setShareAppAlertWhenAppLinkWasCopied: 'Link copiato!',
  setNotificationsInAppTitle: "Nell'App",
  setNotificationsPushContent: 'Notifiche Push',
  setNotificationsChatsTitle: 'Chat',
  setNotificationsDiscussionsTitle: 'Discussioni',
  setNotificationsNewsTitle: 'News Feed',
  setNotificationsEventsTitle: 'Eventi',
  setNotificationsAdminTitle: 'Messaggi Admin',
  setNotificationsBlogTitle: 'Blog',
  setNotificationsPushOffContent: 'Le notifiche Push sono disattivate',
  setNotificationsPushOffText: 'Per abilitarle, vai nelle impostazioni del tuo dispositivo e abilita le notifiche',
  setReportAppFlagCurtainTitle: 'Segnala',
  setAppReportedCurtainContent: 'Contenuto segnalato',
  setDeleteCurtainTitle: 'Elimina Account',
  setDeleteCurtainInputContent: 'Password',
  setDeleteCurtainCancelButtonTitle: 'Annulla',
  setDeleteCurtainConfirmButtonTitle: 'Conferma',
  setDeleteCurtainIncorrectPasswordAlertText: 'Password errata',
  setTurnNotificationsOnText: 'Per attivarle, fai clic sul pulsante qui sotto e permetti di ricevere le notifiche.',
  setTurnNotificationsOnButton: 'Attiva notifiche Push',
  changeLanguage: "Cambia lingua dell'app",
  changeLanguageAlertSuccess: "La lingua dell'app è stata cambiata con successo"
}
